module.exports = __webpack_public_path__ + "img/balkon a v solmsstr voor.d411d1eb.jpg";